import { useState } from "react";

interface PreviousDrugRow {
  drug: string;
  dose: string;
  dates: string;
  outcome: string;
}

interface PreviousDrugsTableProps {
  value?: PreviousDrugRow[];
  onChange: (value: PreviousDrugRow[]) => void;
}

const PreviousDrugsTable = ({
  value = [],
  onChange,
}: PreviousDrugsTableProps) => {
  // Initialize with 4 empty rows if no value provided (as shown in the PDF)
  const [drugs, setDrugs] = useState<PreviousDrugRow[]>(
    value.length > 0
      ? value
      : [
          { drug: "", dose: "", dates: "", outcome: "" },
          { drug: "", dose: "", dates: "", outcome: "" },
          { drug: "", dose: "", dates: "", outcome: "" },
          { drug: "", dose: "", dates: "", outcome: "" },
        ],
  );

  const updateDrug = (
    index: number,
    field: keyof PreviousDrugRow,
    newValue: string,
  ) => {
    const updatedDrugs = [...drugs];
    updatedDrugs[index] = {
      ...updatedDrugs[index],
      [field]: newValue,
    };
    setDrugs(updatedDrugs);
    onChange(updatedDrugs);
  };

  return (
    <div className="previous-drugs-table">
      <div className="mb-4">
        <h4 className="mb-2 text-sm font-medium text-primaryGray-1">
          E. List previous drugs the patient tried. (List the name, date
          prescribed, and any other important information.)
        </h4>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full border border-primaryGray-12">
          <thead>
            <tr className="bg-primaryGray-17">
              <th className="border border-primaryGray-12 px-3 py-2 text-left text-sm font-medium text-primaryGray-1">
                Drug
              </th>
              <th className="border border-primaryGray-12 px-3 py-2 text-left text-sm font-medium text-primaryGray-1">
                Dose
              </th>
              <th className="border border-primaryGray-12 px-3 py-2 text-left text-sm font-medium text-primaryGray-1">
                Dates
              </th>
              <th className="border border-primaryGray-12 px-3 py-2 text-left text-sm font-medium text-primaryGray-1">
                Outcome
              </th>
            </tr>
          </thead>
          <tbody>
            {drugs.map((drug, index) => (
              <tr key={index} className="bg-white">
                <td className="border border-primaryGray-12 px-2 py-2">
                  <input
                    type="text"
                    value={drug.drug}
                    onChange={(e) => updateDrug(index, "drug", e.target.value)}
                    className="w-full border-none bg-transparent px-1 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-tertiaryBlue-4"
                    placeholder="Enter drug name"
                  />
                </td>
                <td className="border border-primaryGray-12 px-2 py-2">
                  <input
                    type="text"
                    value={drug.dose}
                    onChange={(e) => updateDrug(index, "dose", e.target.value)}
                    className="w-full border-none bg-transparent px-1 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-tertiaryBlue-4"
                    placeholder="e.g., 10mg"
                  />
                </td>
                <td className="border border-primaryGray-12 px-2 py-2">
                  <input
                    type="text"
                    value={drug.dates}
                    onChange={(e) => updateDrug(index, "dates", e.target.value)}
                    className="w-full border-none bg-transparent px-1 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-tertiaryBlue-4"
                    placeholder="e.g., 01/2024-03/2024"
                  />
                </td>
                <td className="border border-primaryGray-12 px-2 py-2">
                  <input
                    type="text"
                    value={drug.outcome}
                    onChange={(e) =>
                      updateDrug(index, "outcome", e.target.value)
                    }
                    className="w-full border-none bg-transparent px-1 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-tertiaryBlue-4"
                    placeholder="e.g., Failed, Effective"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PreviousDrugsTable;
